import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCode } from 'react-icons/fa';
import {
  Nav,
  Logo,
  LogoMark,
  LogoText,
  NavMenu,
  NavItem,
  NavLink,
  NavActions,
  NavCta,
  Hamburger,
  MobileDrawer,
  MobileHeader,
  MobileLabel,
  MobileNote,
  MobileNavGroup,
  MobileLink,
  MobileActions,
  MobileCta,
  Overlay,
  LangToggle,
  LangBtn,
} from './Navbar.styles';

const Navbar: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const links = [
    { label: t('nav.home'), to: '/' },
    { label: t('nav.services'), to: '/uslugi' },
    { label: t('nav.portfolio'), to: '/portfolio' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <Nav $scrolled={scrolled}>
        <Logo to="/">
          <LogoMark>
            <FaCode size={18} />
          </LogoMark>
          <LogoText>ERCOMP</LogoText>
        </Logo>

        <NavMenu>
          {links.map((l, index) => (
            <NavItem key={l.to}>
              <NavLink
                to={l.to}
                $active={pathname === l.to}
                aria-current={pathname === l.to ? 'page' : undefined}
              >
                <small>{String(index + 1).padStart(2, '0')}</small>
                <span>{l.label}</span>
              </NavLink>
            </NavItem>
          ))}
        </NavMenu>

        <NavActions>
          <LangToggle>
            <LangBtn $active={i18n.language === 'pl'} onClick={() => i18n.changeLanguage('pl')}>PL</LangBtn>
            <LangBtn $active={i18n.language === 'en'} onClick={() => i18n.changeLanguage('en')}>EN</LangBtn>
          </LangToggle>
          <NavCta to="/kontakt">{t('nav.contact')}</NavCta>
        </NavActions>

        <Hamburger
          type="button"
          $open={open}
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span />
          <span />
          <span />
        </Hamburger>
      </Nav>

      <MobileDrawer $open={open}>
        <MobileHeader>
          <MobileLabel>{t('nav.mobileLabel')}</MobileLabel>
          <MobileNote>{t('nav.mobileNote')}</MobileNote>
        </MobileHeader>

        <MobileNavGroup>
          {links.map((l, index) => (
            <MobileLink key={l.to} to={l.to} $active={pathname === l.to}>
              <small>{String(index + 1).padStart(2, '0')}</small>
              <span>{l.label}</span>
            </MobileLink>
          ))}
        </MobileNavGroup>

        <MobileActions>
          <LangToggle>
            <LangBtn $active={i18n.language === 'pl'} onClick={() => i18n.changeLanguage('pl')}>PL</LangBtn>
            <LangBtn $active={i18n.language === 'en'} onClick={() => i18n.changeLanguage('en')}>EN</LangBtn>
          </LangToggle>
          <MobileCta to="/kontakt">{t('nav.contact')}</MobileCta>
        </MobileActions>
      </MobileDrawer>

      <Overlay $open={open} onClick={() => setOpen(false)} />
    </>
  );
};

export default Navbar;
